import React, {useState, useContext, useEffect} from 'react'
import logo from '../img/logo.svg'
import {ContextApp} from '../context/ContextApp'
import Spinner from './Spinner'

const ModalBuyByCard = ({
  totalToPayBuyer,
  setShowModalToCardPay,
  showModalToCardPay,
}) => {
  const contextApp = useContext(ContextApp)
  const {paymentWithCreditCard, errorCardPaymentMsg, user} = contextApp

  const [cardInfo, setCardInfo] = useState({
    cardNumber: '',
    cvv_card: '',
    expiration_card_year: '',
    expiration_month: '',
  })

  const handleInput = e => {
    setCardInfo({
      ...cardInfo,
      [e.target.name]: e.target.value,
    })
  }
  const [classNone, setClassNone] = useState('')

  const handleSubmit = e => {
    e.preventDefault()
    setClassNone('display-none-buy-card')
    setShowSpinner(true)
    paymentWithCreditCard(cardInfo)
  }

  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    if (errorCardPaymentMsg !== null) {
      setShowSpinner(false)
      setClassNone('')
    }
  }, [errorCardPaymentMsg])

  return (
    <div className="modal-buy-card">
      <div className="modal-content">
        <div
          className="btn_close"
          onClick={() =>
            setShowModalToCardPay(showModalToCardPay ? false : true)
          }
        >
          <i className="fas fa-times"></i>
        </div>
        <div className="grid-modal-buy-card">
          <div className="section-info-buy-modal">
            <img src={logo} alt="" />
            <div className="information-products-price">
              <span>Total a pagar:</span>
              <span className="amount-to-pay">
                {' '}
                ${totalToPayBuyer.toFixed(2)}
              </span>
            </div>
            <div className="msg-diu-alert">
              <span>
                <span>Nota</span>: El repartidor le pedirá la tarjeta y DUI para
                confirmar datos antes de entregarle su pedido.
              </span>
            </div>
            {errorCardPaymentMsg == null ? null : (
              <div className="error-msg-card-er">
                <span>{errorCardPaymentMsg}</span>
              </div>
            )}
          </div>
          <div className="section-form-modal-buy">
            <form onSubmit={e => handleSubmit(e)}>
              <div className="input-content">
                <label htmlFor="">Nombre</label>
                <input
                  type="text"
                  name="cardNumber"
                  id=""
                  placeholder="Ingresa tu nombre"
                  required="true"
                  defaultValue={user.user.name}
                />
              </div>
              <div className="input-content">
                <label htmlFor="">DUI</label>
                <input
                  type="text"
                  name="cardNumber"
                  id=""
                  placeholder="DUI"
                  required="true"
                  defaultValue={user.user.dui}
                />
              </div>
              <div className="input-content">
                <label htmlFor="">Numero de tarjeta</label>
                <input
                  type="text"
                  name="cardNumber"
                  id=""
                  placeholder="9999994570392223"
                  onChange={e => handleInput(e)}
                  required="true"
                />
              </div>
              <div className="grid-modal-inputs">
                <div className="input-content">
                  <label htmlFor="">Año</label>
                  <select
                    name="expiration_card_year"
                    id=""
                    onChange={e => handleInput(e)}
                  >
                    <option value="30">30</option>
                    <option value="29">29</option>
                    <option value="28">28</option>
                    <option value="27">27</option>
                    <option value="26">26</option>
                    <option value="25">25</option>
                    <option value="24">24</option>
                    <option value="23">23</option>
                    <option value="22">22</option>
                    <option value="21">21</option>
                    <option value="20">20</option>
                  </select>

                  {/* <input type="text" name="expiration_card_year" id="" placeholder="20"
                                        onChange={e => handleInput(e)}
                                        required="true"
                                    />
                                    <small class="form-text text-muted">Únicamente los últimos 2 dígitos.</small> */}
                </div>
                <div className="input-content">
                  <label htmlFor="">Mes</label>
                  <select
                    name="expiration_month"
                    id=""
                    onChange={e => handleInput(e)}
                  >
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  {/* <input type="text" name="expiration_month" id="" placeholder="08"
                                        onChange={e => handleInput(e)}  
                                        required="true"                                      
                                    /> */}
                </div>
              </div>
              <div className="info-modal-month-year">
                <span>Mes y año de caducidad de tu tarjeta</span>
              </div>

              <div className="input-content">
                <label htmlFor="">CVC</label>
                <input
                  type="text"
                  name="cvv_card"
                  id=""
                  placeholder="123"
                  onChange={e => handleInput(e)}
                  required="true"
                />
                <small class="form-text text-muted">
                  Únicamente los 3 dígitos.
                </small>
              </div>
              <button type="submit" className={classNone}>
                <i className="fas fa-credit-card"></i> Comprar con tarjeta
              </button>
              {showSpinner ? (
                <div className="spinner-modal">
                  <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              ) : null}
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalBuyByCard
